import { FC } from 'react';
import { ReactSortable } from 'react-sortablejs';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import { ELEMENT_IDS } from './consts';
import styles from './index.module.scss';
import SortableAudioUploaderItem from './SortableAudioUploaderItem';
import { SortableAudioUploaderProps, SortablePromoUploadStatusType } from './types';

const SortableAudioUploader: FC<SortableAudioUploaderProps> = ({
  uploadButtonText,
  uploadDescription,
  acceptValue,
  inputRef,
  items,
  player,
  onUploadClick,
  onFilesChange,
  onPlayClick,
  onRemoveClick,
  onRetryClick,
  onReorder,
}) => (
  <div className={styles.root}>
    <Button
      elementId={ELEMENT_IDS.uploadButton}
      type={ButtonType.SECONDARY}
      onClick={onUploadClick}>
      {uploadButtonText}
    </Button>

    <input
      ref={inputRef}
      data-testid={ELEMENT_IDS.uploadInputTestId}
      type="file"
      multiple
      accept={acceptValue}
      className={styles.fileInputNative}
      onChange={onFilesChange}
    />

    <p className={styles.description}>{uploadDescription}</p>

    <ReactSortable<SortablePromoUploadStatusType>
      tag="ul"
      list={items as SortablePromoUploadStatusType[]}
      handle={`.${styles.dragHandle}`}
      setList={onReorder}
      className={styles.list}>
      {items.map((item) => (
        <SortableAudioUploaderItem
          key={item.id || item.file?.name || item.title || item.filename}
          item={item}
          player={player}
          onPlayClick={onPlayClick}
          onRemoveClick={onRemoveClick}
          onRetryClick={onRetryClick}
        />
      ))}
    </ReactSortable>
  </div>
);

export default SortableAudioUploader;
